export const gameCards = [
  {
    name: "kamek",
    image: require("./images/kamek.png"),
  },
  {
    name: "boo",
    image: require("./images/boo.png"),
  },
  {
    name: "bobomb",
    image: require("./images/bobomb.png"),
  },
  {
    name: "birdo",
    image: require("./images/birdo.png"),
  },
  {
    name: "cheepcheep",
    image: require("./images/cheepcheep.png"),
  },
  {
    name: "koopa",
    image: require("./images/koopa.png"),
  },
  {
    name: "shyguy",
    image: require("./images/shyguy.png"),
  },
  {
    name: "mushroom",
    image: require("./images/mushroom.png"),
  },
  {
    name: "thwomp",
    image: require("./images/thwomp.png"),
  },
  {
    name: "bulletbill",
    image: require("./images/bulletbill.png"),
  },
  {
    name: "lakitu",
    image: require("./images/lakitu.png"),
  },
  {
    name: "goomba",
    image: require("./images/goomba.png"),
  },
];
